import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { VERTICAL_ROUTE_MAP, getVerticalIdFromPath } from 'config/verticalRoutes'

const BASE_TITLE = 'IVIX'
const DEFAULT_PAGE_TITLE = 'Platform'
const ENTITY_PAGE_SUFFIX = ' · Entity Overview'

const getPageTitle = (pathname: string): string => {
  const verticalId = getVerticalIdFromPath(pathname)
  const verticalTitle = verticalId && VERTICAL_ROUTE_MAP[verticalId]?.title

  if (!verticalTitle) return DEFAULT_PAGE_TITLE

  const isEntityPage = pathname.startsWith('/vertical/')
  return isEntityPage ? `${verticalTitle}${ENTITY_PAGE_SUFFIX}` : verticalTitle
}

export const usePageTitle = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = `${getPageTitle(pathname)} | ${BASE_TITLE}`
  }, [pathname])
}
